import { render, staticRenderFns } from "./OneCard.vue?vue&type=template&id=95213fe2&scoped=true&"
import script from "./OneCard.vue?vue&type=script&lang=js&"
export * from "./OneCard.vue?vue&type=script&lang=js&"
import style0 from "./OneCard.vue?vue&type=style&index=0&id=95213fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95213fe2",
  null
  
)

export default component.exports